import {getChampionshipName} from './championship';

const getAvailableFlagsButtons = (championships, isMPP) => {
  const availableChampionships = Object.keys(championships).filter(
    champ =>
      !isMPP || (isMPP && (champ === '1' || champ === '4' || champ === '6')),
  );

  const availableButtons = availableChampionships.map(champ => {
    return getChampionshipName(Number(champ));
  });
  return availableButtons;
};

export default getAvailableFlagsButtons;



// WEBPACK FOOTER //
// ./src/helpers/getAvailableFlagsButtons.js